/** The agency's share links. Shapes mirror apps/api/src/share-routes.ts. */

import { apiCall, orgPath } from '../api.ts';
import type { RangeSetting } from './reports-api.ts';

export interface ShareLink {
  id: string;
  document_id: string;
  source_document_id: string;
  name: string;
  url: string;
  allow_range_change: boolean;
  has_password: boolean;
  expires_at: string | null;
  revoked_at: string | null;
  view_count: number;
  last_viewed_at: string | null;
  created_at: string;
}

export interface NewShareLink {
  name: string;
  allow_range_change: boolean;
  range?: RangeSetting;
  expires_at?: string | null;
  password?: string | null;
}

const reports = (org: string, path: string) => orgPath(org, `/reports${path}`);

export const sharesApi = {
  list: (org: string, documentId: string) =>
    apiCall<{ shares: ShareLink[] }>(reports(org, `/documents/${documentId}/shares`)).then(
      (data) => data.shares,
    ),
  create: (org: string, documentId: string, input: NewShareLink) =>
    apiCall<{ share: ShareLink }>(reports(org, `/documents/${documentId}/shares`), {
      method: 'POST',
      body: JSON.stringify(input),
    }).then((data) => data.share),
  update: (org: string, id: string, input: Partial<NewShareLink>) =>
    apiCall<{ share: ShareLink }>(reports(org, `/shares/${id}`), {
      method: 'PATCH',
      body: JSON.stringify(input),
    }).then((data) => data.share),
  revoke: (org: string, id: string) =>
    apiCall<{ revoked: boolean }>(reports(org, `/shares/${id}`), { method: 'DELETE' }),
};
